import React from 'react';

import { ToroLearnButton } from 'presentation/components/button';

import './styles.scss';
import { trackingEvent } from 'data/usecases/tracking-event';

interface IProps {
    moduleId: number;
    lessonId: number;
    courseSlug: string;
    thumbnailUrl: string;
    lessonName: string;
    courseName: string;
    moduleName: string;
}

export const NextLessonBanner = ({
    moduleId,
    courseName,
    lessonId,
    courseSlug,
    thumbnailUrl,
    lessonName,
    moduleName,
}: IProps) => (
    <div className="next-lesson-banner">
        <div className="content">
            <p className="lessons-name font-size-9 mb-0">
                Módulo {moduleId + 1} | Aula {lessonId + 1}
            </p>
            <p className="font-weight-bold font-size-8">{lessonName}</p>
            <ToroLearnButton
                onClick={() => {
                    trackingEvent.elementClicked({
                        productAreaOrigin: 'Aprenda',
                        element: 'Botão Continue assistindo',
                        group: lessonName,
                        step: `${moduleName}/${lessonName}`,
                        label: 'Continue assistindo',
                        text: courseName,
                        timeResponsavel: 'Sky',
                    });
                }}
                href={`/${courseSlug}/${moduleId + 1}/${lessonId + 1}`}
                btnType="btn-secondary"
                icon="play-circle"
            >
                <span className="font-weight-bold">Continue assistindo</span>
            </ToroLearnButton>
        </div>
        <div className="thumbnail">
            <img className="img-fluid" src={thumbnailUrl} alt={lessonName} />
            <ToroLearnButton
                href={`/${courseSlug + 1}/${moduleId + 1}/${lessonId + 1}`}
                btnType="btn-link"
                icon="play"
            />
        </div>
    </div>
);
